import maplibregl, { Map as FleetGLMap, Marker } from "maplibre-gl";
import { Facility, FleetVehicle } from "./fleetData";
import { destinationFeatures } from "./fleetMapLayers";

export function createBaseFlag(name:string,assetUrl:string): HTMLElement {
  const element=document.createElement("span");element.className="fleet-base-flag";
  element.setAttribute("role","img");element.setAttribute("aria-label","Base · "+name);
  const pole=document.createElement("span");pole.className="fleet-base-flag-pole";pole.setAttribute("aria-hidden","true");
  const cloth=document.createElement("img");cloth.className="fleet-base-flag-cloth";cloth.src=assetUrl;cloth.alt="BASE";cloth.draggable=false;
  const foot=document.createElement("span");foot.className="fleet-base-flag-foot";foot.setAttribute("aria-hidden","true");
  element.append(pole,cloth,foot);
  return element;
}

export function syncBaseFlags(map:FleetGLMap,markers:Map<string,Marker>,vehicles:FleetVehicle[],facilities:Facility[],assetUrl:string) {
  const keep=new Set<string>();
  destinationFeatures(vehicles,facilities).features.forEach(feature=>{
    if(feature.properties?.kind!=="base") return;
    const [lng,lat]=feature.geometry.coordinates;
    const key=lng+":"+lat;keep.add(key);
    let marker=markers.get(key);
    if(!marker) {
      marker=new maplibregl.Marker({element:createBaseFlag(feature.properties.name,assetUrl),anchor:"bottom-left",offset:[-5,0],pitchAlignment:"viewport",rotationAlignment:"viewport"})
        .setLngLat([lng,lat]).addTo(map);
      markers.set(key,marker);
    } else {
      marker.setLngLat([lng,lat]);
      marker.getElement().setAttribute("aria-label","Base · "+feature.properties.name);
    }
  });
  markers.forEach((marker,key)=>{if(!keep.has(key)){marker.remove();markers.delete(key);}});
}
